"use client";
import { jsx as n } from "react/jsx-runtime";
import { IconHourglassFilled as i, IconInfoFilled as t, IconMinusCircleFilled as l, IconErrorFilled as s, IconWarningFilled as m, IconCheckmarkCircleFilled as d } from "@zillow/constellation-icons";
import { forwardRef as f } from "react";
import { Icon as I } from "../icon/icon.js";
const p = f(
  (o, r) => {
    const { tone: c = "info", ...a } = o;
    let e;
    switch (c) {
      case "complete":
      case "success":
        e = /* @__PURE__ */ n(d, {});
        break;
      case "warning":
        e = /* @__PURE__ */ n(m, {});
        break;
      case "critical":
        e = /* @__PURE__ */ n(s, {});
        break;
      case "incomplete":
        e = /* @__PURE__ */ n(l, {});
        break;
      case "info":
        e = /* @__PURE__ */ n(t, {});
        break;
      case "transient":
        e = /* @__PURE__ */ n(i, {});
        break;
      default:
        return;
    }
    return /* @__PURE__ */ n(
      I,
      {
        "data-c11n-component": "ToneIcon",
        "data-c11n-version": "10.0.0-alpha.19",
        ref: r,
        ...a,
        children: e
      }
    );
  }
);
p.displayName = "ToneIcon";
export {
  p as ToneIcon
};
//# sourceMappingURL=tone-icon.js.map
